import { createActionCreator } from '@pressreader/appstore';
import { TargetPlatform } from '@pressreader/types';

import { MODULE_NAME } from '../constants';
import { Platform } from '../types';
import { OnlineStatus } from '../types/online.status';

const prefix = `${MODULE_NAME}/`;

interface CoreModuleLoadPayload {
    targetPlatform: TargetPlatform;
    faceliftEnabled: boolean;
    isWebSDK?: boolean;
}
export const coreModuleLoadDone = createActionCreator<CoreModuleLoadPayload>(`${prefix}core-module-load-done`);

export const startAppAction = createActionCreator<{
    /** Whether app/common/navigation module should track navigation. Default true. */
    handleRouting?: boolean;
}>(`${prefix}start-app`);

export const appStarted = createActionCreator(`${prefix}app_started`);

export const changeTargetPlatformAction = createActionCreator<{
    newTargetPlatform: TargetPlatform;
    keepLocation?: boolean;
}>(`${prefix}change-target-platform`);

export const toggleFaceliftUiAction = createActionCreator<{
    enable: boolean;
}>(`${prefix}toggle-facelift-ui`);

export const legacyPlatformChanged = createActionCreator<{
    platform: Platform;
}>(`${prefix}legacy-platform-changed`);

export const currentWindowActivated = createActionCreator(`${prefix}document-visibility-active`);

export const updateCoreModuleStateAction = createActionCreator<Partial<CoreModuleLoadPayload>>(`${prefix}update-core-module-state-action`);

export const setOnlineStatus = createActionCreator<OnlineStatus>(`${prefix}set-online-status`);

export const watchOnlineStatus = createActionCreator(`${prefix}watch-online-status`);
